<template>
	<div class="related-posts-ajax" v-if="posts.length > 0">
		<div class="snippet-related-posts">
			<div class="snippet-related-posts__container">
				<div class="snippet-related-posts__left">
					<span class="snippet-related-posts__hashtag">#puorilife</span>
					<h3 class="snippet-related-posts__title">
						Check out these blog posts related to {{ title }}.
					</h3>
					<p class="snippet-related-posts__lead">
						General text about our vast content universe and a link here
					</p>
					<a :href="url" class="button">See more here</a>
				</div>

				<div class="snippet-related-posts__right">
					<related-posts :posts="posts.articles" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import RelatedPosts from "./related-posts.vue";

export default {
	name: "RelatedPostsAjax",
	components: { RelatedPosts },
	selector: "#vue-related-posts-ajax",
	props: {
		tag: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: true,
			posts: []
		};
	},
	computed: {
		url() {
			return `/blogs/news/tagged/${this.tag}`;
		}
	},
	async mounted() {
		try {
			const { data } = await this.$http(this.url, {
				params: {
					view: "ajax"
				}
			});
			this.posts = data;
		} catch (_) {
			// 404 -- no posts with tag
		} finally {
			this.loading = false;
		}
	}
};
</script>

<style>
</style>